import React, { useEffect, useState } from 'react';
// react-select/async unresolves on v1.2.1, which is used on web-app in referrals form
// when web-app starts using patientForms, we will need to migrate from 1.2.1 to 3.0.4 on referrals form
import ReactSelect from 'react-select';

import { withStyles } from '@material-ui/core';

import SelectControl from './SelectControl';
import SelectOption from './SelectOption';

const styles = () => ({
  input: {
    display: 'flex',
  },
});

export interface SelectProps {
  // TODO: add types to Select
  [key: string]: any;
}

function Select({
  components,
  loadOptions,
  loadingMessage,
  noOptionsMessage,
  isClearable,
  isMulti,
  options: initialOptions,
  ...other
}: SelectProps) {
  const [inputValue, setInputValue] = useState<string>();
  const [options, setOptions] = useState(initialOptions || []);
  const [loading, setLoading] = useState(false);

  // workaround to keep search value on input when on blur
  const onInputChange = (value: string, action: { action: string }) => {
    // action can be null on react-select v1.x.x used on web-app
    if (!['input-blur', 'menu-close'].includes((action || {}).action)) {
      setInputValue(value);
      if (loadOptions) {
        setLoading(true);
        loadOptions(value, (optionsValue: any) => {
          setLoading(false);
          setOptions(optionsValue);
        });
      }
    }
  };

  // Insurance component is using redux store for payer options. It does not call the callback passed to loadoptions method, it dispatches redux action and updates store and then props.
  useEffect(() => {
    setOptions(initialOptions);
  }, [initialOptions]);

  const defaultLoadingMessage = () => 'Searching';
  const defaultNoOptionsMessage = () => 'No options';

  const componentsExtended: any = {
    Control: SelectControl,
    Option: SelectOption,
    DropdownIndicator: () => <div />,
    IndicatorSeparator: () => <div />,
    ...components,
  };

  return (
    <ReactSelect
      options={options}
      components={componentsExtended}
      inputValue={inputValue}
      onInputChange={onInputChange}
      filterOption={loadOptions ? () => true : undefined}
      noOptionsMessage={loading ? loadingMessage || defaultLoadingMessage : noOptionsMessage || defaultNoOptionsMessage}
      isClearable={isClearable}
      isMulti={isMulti}
      // props below are due to react-select v1.x.x used on web-app
      clearable={isClearable}
      multi={isMulti}
      menuPlacement="auto"
      menuPosition="absolute"
      {...other}
    />
  );
}

export default withStyles(styles)(Select);
